module.exports = __webpack_public_path__ + "assets/icon_tasks.59834adf.svg";